// Get All Clients
export const GET_ALL_CLIENTS_REQUEST = "GET_ALL_CLIENTS_REQUEST";
export const GET_ALL_CLIENTS_SUCCESS = "GET_ALL_CLIENTS_SUCCESS";
export const GET_ALL_CLIENTS_FAIL = "GET_ALL_CLIENTS_FAIL";

// Get Client by ID
export const GET_CLIENT_BY_ID_REQUEST = "GET_CLIENT_BY_ID_REQUEST";
export const GET_CLIENT_BY_ID_SUCCESS = "GET_CLIENT_BY_ID_SUCCESS";
export const GET_CLIENT_BY_ID_FAIL = "GET_CLIENT_BY_ID_FAIL";

// Add Client
export const ADD_CLIENT_REQUEST = "ADD_CLIENT_REQUEST";
export const ADD_CLIENT_SUCCESS = "ADD_CLIENT_SUCCESS";
export const ADD_CLIENT_FAIL = "ADD_CLIENT_FAIL";

// Edit Client Status (NEW)
export const UPDATE_CLIENT_STATUS_REQUEST = "UPDATE_CLIENT_STATUS_REQUEST";
export const UPDATE_CLIENT_STATUS_SUCCESS = "UPDATE_CLIENT_STATUS_SUCCESS";
export const UPDATE_CLIENT_STATUS_FAIL = "UPDATE_CLIENT_STATUS_FAIL";